import { BaseStatementPagePath } from "app/core/workflow/page-path/statement-page-path/base-statement-page.path";

export class SendCertificateComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return "statement/:statementId/send-certificate";
  }

  public static pathWithHash(): string {
    return "statement/:statementId/send-certificate/:hash";
  }

  public static regex(): RegExp {
    return /\/statement\/\d+\/send-certificate((\/?#?)|(\/?#.*?))$/;
  }
}
